import dayjs from "dayjs"
import isSameOrAfter from "dayjs/plugin/isSameOrAfter"
dayjs.extend(isSameOrAfter)

const hasUpcomingSmartMeterBooking = (date) => {
  return dayjs(date).isSameOrAfter(dayjs(), "date")
}

const hasSmartMeterBooking = (
  smbpData,

  hasActiveAgreements
) => {
  return (
    hasActiveAgreements &&
    smbpData?.booked &&
    smbpData?.bookingData?.date &&
    smbpData?.bookingData?.startTime &&
    hasUpcomingSmartMeterBooking(smbpData?.bookingData?.date)
  )
}

const oneMonthReadReminderBanner = {
  id: "one-month-read-banner",
  cookieName: "myaccount_banner-dismissal_one-month-read-banner",
  shouldShow: ({
    dateToday,
    lastReadMinMax,

    hasActiveAgreements,
  }) => {
    const lastMeterRead = dayjs(lastReadMinMax.max).startOf("day")
    const readOlderThanMonth = lastMeterRead.isSameOrBefore(
      dayjs(dateToday).subtract(1, "month")
    )

    return hasActiveAgreements && readOlderThanMonth
  },
}

const directDebitSwitchBanner = {
  id: "direct-debit-switch-banner",
  cookieName: "myaccount_banner-dismissal_direct-debit-switch-banner",
  shouldShow: ({ isSwitchingAway }) => isSwitchingAway,
}

const smartMeterEligibilityBanner = {
  id: "smart-meter-banner",
  cookieName: "myaccount_banner-dismissal_smart-meter-banner",
  shouldShow: ({ isEligibleForSmartMeter }) => isEligibleForSmartMeter,
}

const hasSmartMeterAppointmentBookedBanner = {
  id: "smart-meter-booking-banner",
  cookieName: "myaccount_banner-dismissal_smart-meter-booking-banner",
  shouldShow: ({ smbpData, hasActiveAgreements }) =>
    hasSmartMeterBooking(smbpData, hasActiveAgreements),
}

const accountClosedBanner = {
  id: "account-closed-banner",
  cookieName: "myaccount_banner-dismissal_account-closed-banner",
  shouldShow: ({ hasActiveAgreements, accountOpen }) =>
    !accountOpen && !hasActiveAgreements,
}

const switchCompleteBanner = {
  id: "switch-complete-banner",
  cookieName: "myaccount_banner-dismissal_switch-complete-banner",
  shouldShow: ({ isSwitchComplete }) => isSwitchComplete,
}

const switchInProgressBanner = {
  id: "switch-in-progress-banner",
  cookieName: "myaccount_banner-dismissal_switch-in-progress-banner",
  shouldShow: ({ isSwitchInProgress }) => isSwitchInProgress,
}

const HOME_PAGE_BANNERS = [
  oneMonthReadReminderBanner,
  directDebitSwitchBanner,
  smartMeterEligibilityBanner,
  hasSmartMeterAppointmentBookedBanner,
  accountClosedBanner,
  switchCompleteBanner,
  switchInProgressBanner,
]

export default (bannerData) => {
  const filteredBanners = []
  HOME_PAGE_BANNERS.forEach(({ cookieName, action, id, shouldShow }) => {
    cookieName = cookieName || `myaccount_banner-dismissal_${id}`
    const storyblokBanner = bannerData.allBanners.find(
      (banner) => banner.banner_id === id
    )

    if (storyblokBanner) {
      const shoudShow = shouldShow({
        allBanners: bannerData.allBanners,
        hasSeasonalPaymentPlan: bannerData.hasSeasonalPaymentPlan,
        hasActiveAgreements: bannerData.hasActiveAgreements,
        lastReadMinMax: bannerData.lastReadMinMax,
        smbpData: bannerData.smbpData,
        dateToday: bannerData.dateToday,
        variables: bannerData.variables,
        isSwitchComplete: bannerData.isSwitchComplete,
        isSwitchInProgress: bannerData.isSwitchInProgress,
        isSwitchingAway: bannerData.isSwitchingAway,
        hasSmartMeter: bannerData.hasSmartMeter,
        accountOpen: bannerData.accountOpen,
        isEligibleForSmartMeter: bannerData.isEligibleForSmartMeter,
      })

      if (shoudShow) {
        filteredBanners.push({
          ...storyblokBanner,
          cookieName,
          action,
        })
      }
    }
  })

  return filteredBanners
}
